import React, { useCallback, useEffect, useState } from "react";
import InfinityScroll from "../../common/InfinityScroll";
import { formatDate } from "../../utils/formatDate";
import formatPrice from "../../utils/formatPrice";
import { pushObjectToState } from "../../utils/push-state";
import invoicesApiClient from "../../clients/InvoicesApiClient";
const AuctionItemDescriptionMaxLength = 50;
export function MyInvoices({ strings }) {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [type, setType] = useState();
    const [nextPageHandle, setNextPageHandle] = useState("");
    function onTypeChange(e) {
        const newType = e.currentTarget.value;
        setType(newType);
        const state = {
            type: newType,
        };
        pushObjectToState(state);
    }
    useEffect(() => {
        if (!type)
            return;
        setLoading(true);
        setInvoices([]);
        setNextPageHandle("");
        void invoicesApiClient.getInvoices(type, "").then((r) => {
            setNextPageHandle(r.nextPageHandle);
            setInvoices(r.invoices);
            setLoading(false);
        });
    }, [type]);
    useEffect(() => {
        var _a;
        const q = new URLSearchParams(location.search);
        setType((_a = q.get("type")) !== null && _a !== void 0 ? _a : "auction");
    }, []);
    const fetchNextPage = useCallback(async () => {
        if (!nextPageHandle || !type)
            return;
        setLoading(true);
        const response = await invoicesApiClient.getInvoices(type, nextPageHandle);
        setInvoices((invoices) => [...invoices, ...response.invoices]);
        setNextPageHandle(response.nextPageHandle);
        setLoading(false);
    }, [type, nextPageHandle]);
    function formatStatus(status) {
        switch (status) {
            case "0":
                return strings.status.systemGenerated;
            case "1":
                return strings.status.pendingRegistration;
            case "2":
                return strings.status.pendingCustomerApproval;
            case "4":
                return strings.status.pendingPayment;
            case "8":
            case "9":
                return strings.status.confirmedPaid;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { className: "my-page-invoice" },
            React.createElement("select", { onChange: onTypeChange },
                React.createElement("option", { value: "auction", selected: type === "auction" }, strings.labels.auction),
                React.createElement("option", { value: "store", selected: type === "store" }, strings.labels.store))),
        React.createElement("article", { className: "my-invoices-items invoice-legend" },
            React.createElement("span", null, strings.labels.orderedDate),
            React.createElement("span", null, strings.labels.number),
            React.createElement("span", null, strings.labels.goods),
            React.createElement("span", null, strings.labels.status),
            React.createElement("span", null, strings.labels.total)),
        invoices.length === 0 && !loading && (React.createElement("article", { className: "my-invoices-items empty" }, strings.labels.empty)),
        invoices.map((invoice) => (React.createElement("article", { className: "my-invoices-items", key: invoice.id },
            React.createElement("span", null,
                React.createElement("span", { className: "mobile" }, strings.labels.orderedDate),
                formatDate(invoice.createdAt)),
            React.createElement("span", null,
                React.createElement("span", { className: "mobile" }, strings.labels.number),
                React.createElement("a", { className: "ordernumber", href: `invoice/${invoice.id}?type=${type}` }, invoice.id)),
            React.createElement("div", null,
                React.createElement("span", { className: "mobile" }, strings.labels.goods),
                invoice.items
                    .filter((_, index) => index < 10)
                    .map((item) => (React.createElement(React.Fragment, null,
                    type === 'store' && React.createElement("p", { key: item.id },
                        item.description,
                        " (",
                        item.quantity,
                        " ",
                        strings.labels.stk,
                        ")"),
                    type === 'auction' && React.createElement("p", { key: item.id, title: item.description }, getAuctionItemDescription(item))))),
                invoice.items.length > 10 && React.createElement("p", { key: "more" }, "...")),
            React.createElement("div", null,
                React.createElement("span", { className: "mobile" }, strings.labels.status),
                React.createElement("div", null, formatStatus(invoice.status)),
                invoice.status !== "9" && invoice.status !== "8" && (React.createElement("a", { href: `invoice/${invoice.id}?type=${type}` },
                    React.createElement("strong", null, strings.labels.pay)))),
            React.createElement("span", null,
                React.createElement("span", { className: "mobile" }, strings.labels.total),
                formatPrice(invoice.totalAmount))))),
        React.createElement(InfinityScroll, { callback: fetchNextPage, loading: loading })));
}
export function createAuctionItemDescription(item) {
    return item.description.length > AuctionItemDescriptionMaxLength
        ? (item.description.substring(0, AuctionItemDescriptionMaxLength) + '...')
        : item.description;
}
function getAuctionItemDescription(item) {
    return item.name.replace('LOT/', '') + ' ' + createAuctionItemDescription(item);
}
